import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService, ArchivosConvenios } from '../../../../services/tools/helpers.service';
import { ArchivosConveniosService } from '../../../../services/archivos-convenios.service';

@Component({
  selector: 'archivo-convenio',
  templateUrl: './archivo-convenio.component.html',
  styleUrls: ['./archivo-convenio.component.scss']
})
export class ArchivoConvenioComponent implements OnInit {

  @Input() public idConvenios : number = null;
  @Input() public tipoArchivo : string = null;
  @Output() public onUploadFile :EventEmitter<any> = new EventEmitter;
  @Output() public onDeleteFile :EventEmitter<any> = new EventEmitter;
  //Cliente form
  public uploadingFile : boolean = false;
  public errors:any = {};
  public idTipoArchivo : number = 0;
  public archivo : any = null;

  constructor(
    private helperService : HelpersService,
    private archivosService : ArchivosConveniosService
  ){
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tipoArchivo && this.tipoArchivo) {
      switch(this.tipoArchivo){
        case 'ConstanciaLegal':
            this.idTipoArchivo = ArchivosConvenios.ConstanciaLegal;
            break;
        case 'ActaConstitutiva':
            this.idTipoArchivo = ArchivosConvenios.ActaConstitutiva;
            break;
        case 'ComprobanteDomicilio':
            this.idTipoArchivo = ArchivosConvenios.ComprobanteDomicilio;
            break;
        case 'INE':
            this.idTipoArchivo = ArchivosConvenios.INE;
            break;
      }
    }

    //Obtener la información del archivo asociado a este tipo
    if (this.idConvenios && this.idTipoArchivo) {
        this.getArchivos(this.idConvenios, this.idTipoArchivo);
    }
  }

  private getArchivos(idConvenios : number, tipo : number){
      
    //TODO: Manejar cuando el id no retorna un crédito valido
    this.archivosService.get(idConvenios, tipo).subscribe(
      (response)=>
      {
        let arrayArchivos = response.json().content;
        if(arrayArchivos && arrayArchivos.length > 0){
            this.archivo = arrayArchivos[0];
        }
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  /**
   * Upload files
   */
  uploadFile(event : any) {
    //Show spinner
    this.uploadingFile = true;

    let fileInfo = 
    {
        tipo : this.idTipoArchivo,
        idConvenios : null
    };

    if(this.idConvenios){
      fileInfo.idConvenios = this.idConvenios;
    }
    
    let observableResponse = this.archivosService.save(event, fileInfo);

    if(!observableResponse){
      //Si al hacer el Upload del archivo se cancela la carga, cae en este escenario 
      this.uploadingFile = false;
      return;
    }

    observableResponse.subscribe(
        (response)=>
        {
          let archivo = response.json().content;
          //Se agrega la info del nuevo archivo a la lista para que se muestre en el formulario
          this.archivo = archivo;
          this.onUploadFile.emit(archivo);
          
          //Hide spinner
          this.uploadingFile = false;

          //Notify result
          this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
        }, error =>
        {
          //Hide spinner
          this.uploadingFile = false;
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }
  
  public downloadFile() {
    this.archivosService.getFile(this.archivo.id).subscribe(
      (response)=>
      {
        const fileUrl = window.URL.createObjectURL(response.blob());
        //Muestra el archivo en una nueva ventana
        window.open(fileUrl);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  
  public deleteFile(){

    this.archivosService.delete(this.archivo.id).subscribe(
      (response)=>
      {
        //Si el archivo fue eliminado, desasignamos el valor del atributo contratoFile
        this.onDeleteFile.emit(this.archivo);
        this.archivo = null;
        this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }


}


// WEBPACK FOOTER //
// ./src/app/convenios/detalles/components/archivo-convenio/archivo-convenio.component.ts